/**
 * RESPONSIBILITY: the @DateField control - date or datetime-local.
 *
 * Registers with a tester + rank. The highest-ranked renderer for a schema node
 * wins, so adding a control is a registration — there is no switch on field type.
 */
import { useState } from 'react';
import { rankWith, and, isStringControl, optionIs, type ControlProps } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';

function DateControlBase({ data, handleChange, path, label, uischema, errors }: ControlProps) {
  const opts = (uischema as { options?: Record<string, unknown> }).options ?? {};
  const withTime = Boolean(opts.time);

  // <input type=date> wants YYYY-MM-DD; datetime-local wants YYYY-MM-DDTHH:mm.
  const value = String(data ?? '').slice(0, withTime ? 16 : 10);

  return (
    <div className="ctl">
      <label className="ctl-label">{label}</label>
      <input
        type={withTime ? 'datetime-local' : 'date'}
        className="ctl-input"
        value={value}
        onChange={(e) => handleChange(path, e.target.value)}
      />
      {errors && <p className="ctl-error">{errors}</p>}
    </div>
  );
}

export const dateControl = {
  tester: rankWith(10, and(isStringControl, optionIs('widget', 'date'))),
  renderer: withJsonFormsControlProps(DateControlBase),
};

/* -------------------------------------------------------------------------- */
/*  List — repeatable rows, add / remove / reorder                             */
/* -------------------------------------------------------------------------- */
